export type SampleId = "flowchart" | "sequence" | "erd" | "architecture" | "timeline";

export type SampleDiagram = {
  id: SampleId;
  label: string;
  koLabel: string;
  code: string;
};

export const sampleDiagrams: SampleDiagram[] = [
  {
    id: "architecture",
    label: "Architecture",
    koLabel: "아키텍처",
    code: `%%{init: {'theme': 'neutral', 'flowchart': {'curve': 'basis', 'useMaxWidth': true}}}%%
graph TB
  subgraph Client[Client Tier]
    U[Web / Mobile App]
  end

  LB[Load Balancer]

  subgraph App[Application Tier]
    API[API Gateway]
    User[User Service]
    Order[Order Service]
  end

  subgraph Data[Data Tier]
    UserDB[(User DB)]
    OrderDB[(Order DB)]
    Cache[(Cache)]
  end

  subgraph External[External Services]
    Auth[Auth Provider]
    Pay[Payment Gateway]
    Mail[Email Service]
    CDN[CDN / Storage]
  end

  U --> LB
  LB --> API
  API --> User
  API --> Order
  User --> UserDB
  Order --> OrderDB
  API --> Cache
  API -.-> Auth
  Order -.-> Pay
  User -.-> Mail
  U -.-> CDN`
  },
  {
    id: "flowchart",
    label: "Flowchart",
    koLabel: "플로우",
    code: `flowchart LR
accTitle: Deployment decision flow
accDescr: Flowchart for deciding whether a release should ship or return to review.
  A[Open pull request] --> B{Checks pass?}
  B -- No --> C[Fix build or tests]
  C --> A
  B -- Yes --> D{Docs updated?}
  D -- No --> E[Add release notes]
  E --> D
  D -- Yes --> F[Merge and deploy]
  F --> G[Monitor production]`
  },
  {
    id: "sequence",
    label: "Sequence",
    koLabel: "시퀀스",
    code: `sequenceDiagram
accTitle: Passwordless login sequence
accDescr: Sequence diagram showing a passwordless login link sent by email.
  actor User
  participant Web
  participant Auth
  participant Mail
  User->>Web: Enter email
  Web->>Auth: Create login token
  Auth->>Mail: Send magic link
  Mail-->>User: Login email
  User->>Web: Open link
  Web->>Auth: Validate token
  Auth-->>Web: Session
  Web-->>User: Dashboard`
  },
  {
    id: "erd",
    label: "ERD",
    koLabel: "ERD",
    code: `erDiagram
accTitle: Commerce entity relationship diagram
accDescr: Entity relationship diagram for customers, orders, products, and line items.
  CUSTOMER ||--o{ ORDER : places
  ORDER ||--|{ LINE_ITEM : contains
  PRODUCT ||--o{ LINE_ITEM : appears_in
  CUSTOMER {
    string id
    string email
    string plan
  }
  ORDER {
    string id
    date created_at
    string status
  }
  PRODUCT {
    string sku
    string name
  }
  LINE_ITEM {
    int quantity
    decimal price
  }`
  },
  {
    id: "timeline",
    label: "Timeline",
    koLabel: "타임라인",
    code: `timeline
accTitle: Launch readiness timeline
accDescr: Timeline showing launch readiness checkpoints from content freeze to post launch review.
  title Launch readiness
  2026-06-01 : Content freeze
             : Accessibility review
  2026-06-05 : Beta feedback
             : Fix release blockers
  2026-06-10 : Production deploy
  2026-06-14 : Post-launch review`
  }
];

export function getSample(id: SampleId): SampleDiagram {
  return sampleDiagrams.find((sample) => sample.id === id) ?? sampleDiagrams[0];
}
